/**
 * Created by wxb on 2023/07/21.
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Carousel, Button } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div className={className + " zgh-classicCases-carouselLeftSwitch"} tabindex="1" onClick={onClick}>
            <LeftOutlined className="zgh-classicCases-icon1" />
        </div>
    );
}
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div className={className + " zgh-classicCases-carouselRightSwitch"} tabindex="1" onClick={onClick}>
            <RightOutlined className="zgh-classicCases-icon" />
        </div>
    );
}
class index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            carouselNext: "0"
        };
        this.carouselref = React.createRef();
        this.carouselref1 = React.createRef();
    }
    componentDidMount() {
        let data = document.querySelectorAll(".slick-dots button");
        data.forEach((it, idx) => {
            if (idx === 0) {
                it.innerHTML = "产线工艺质量应用"
            } else if (idx === 1) {
                it.innerHTML = "产线设备管理提升"
            } else if (idx === 2) {
                it.innerHTML = "产线数据节能"
            }
        });
    }
    //了解更多
    helpingBusinessesLearnMore = () => {
        const { dataObjectClick } = this.props;
        if (dataObjectClick) {
            dataObjectClick({ key: '2' });
        }
    }
    //经典案例-了解更多
    learnMoreClick = () => {
        const { dataObjectClick } = this.props;
        if (dataObjectClick) {
            dataObjectClick({ key: '3' });
        }
    }
    //经典案例-点击切换
    carouselNext = (e, type) => {
        this.setState({ carouselNext: type }, () => {
            if (type === "1") {
                console.log("执行...", this.carouselref1.current);
                this.carouselref1.current.innerSlider.play()
            } else {
                this.carouselref1.current.next();
            }
        });
    }
    //主页-了解更多
    homePageLearnMore = () => {
        const { dataObjectClick } = this.props;
        if (dataObjectClick) {
            dataObjectClick({ key: '2' });
        }
    }
    //介绍-了解更多
    introduceLearnMore = () => {
        const { dataObjectClick } = this.props;
        if (dataObjectClick) {
            dataObjectClick({ key: '4' });
        }
    }
    render() {
        const { carouselNext } = this.state;
        const contentStyle = {
            height: '488px',
            color: '#fff',
            lineHeight: '488px',
            textAlign: 'center',
            background: '#fff',
            padding: "90px 260px 24px 260px",
            display: "flex"
        };
        const picContentStyle = {
            height: '544px',
            color: '#fff',
            lineHeight: '544px',
            textAlign: 'center',
        };
        const {
            match: { path },
            location: { pathname },
        } = this.props;
        return (
            <>
                <div>
                    <div style={{ height: 64 }}></div>
                    <div className="zgh-contentHeader">
                        <div className={'zgh-contentHeader-card'} >
                            <div className="zgh-contentHeader-title">与工业共赢 与数据同行</div>
                            <div className="zgh-contentHeader-details">为工业企业提供数据解决方案，助力实现数字化转型升级</div>
                            <div className="zgh-contentHeader-learnMore"><Button type="primary" onClick={this.homePageLearnMore}>了解更多</Button></div>
                        </div>
                    </div>
                </div>
                <div className="zgh-pintroduceInfo-card">
                    <p className="zgh-menu-title" style={{ paddingTop: 80 }}>核心产品</p>
                    <div className="zgh-pintroduceInfo-fatherProductBlock">
                        <div className="zgh-pintroduceInfo-leftBlock">
                            <div className="zgh-pintroduceInfo-pintroduceName">ISA全真互联数据工厂</div>
                            <div className="zgh-pintroduceInfo-pintroduceDescribe">将生产过程、生产关系、管理要求形成数据最小单元，通过解构、分析数据特征及需求，形成预测性生产及预测性管理的数据工厂。</div>
                            <div className="zgh-pintroduceInfo-pintroduceDescribeBlock">
                                <div className="zgh-pintroduceInfo-pintroduceDescribeBlock-title">数据驱动预测性生产</div>
                                <div className="zgh-pintroduceInfo-pintroduceDescribeBlock-describe" style={{marginBottom:24}}>以最小生产单元为载体，做到生产过程“可视、可知、可控、可预测”，实现“质量到点、能耗到坯、决策到人、成本到件”，达到生产预测化。”</div>
                                <div className="zgh-pintroduceInfo-pintroduceDescribeBlock-title">数据驱动预测性管理</div>
                                <div className="zgh-pintroduceInfo-pintroduceDescribeBlock-describe">将原有粗放管理梳理成可精确到具体过程的精益管理模式，实现管理“透明化、穿透化、预测化”，帮助管理预判问题、高效感知问题、直击问题要点、动态响应管理要求。</div>
                            </div>
                        </div>
                        <div className="zgh-pintroduceInfo-rightBlock"></div>
                    </div>
                </div>
                <div className="zgh-helpingBusinesses-card">
                    <p className="zgh-menu-title">帮助企业</p>
                    <div className="zgh-helpingBusinesses-describe">以数据驱动工业</div>
                    <div className="zgh-helpingBusinesses-line" style={{marginTop: 32}}>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionVisualization"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产可视化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程全流程可视</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-knowledgeBasedProduction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产知识化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">标准、经验、事件、管理转化为产线知识</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionPrediction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产预测化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程提前预测，提早调整，准备预案</div>
                        </div>
                    </div>
                    <div className="zgh-helpingBusinesses-line">
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-knowledgeableProduction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产可知化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程异常精准感知</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionStandardization"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产标准化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">精细化各专业生产过程标准</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-predictiveManagement"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">管理预测化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">依托过程支持管理细分，多层级穿透式管理</div>
                        </div>
                    </div>
                    <div className="zgh-helpingBusinesses-learnMore" onClick={() => this.helpingBusinessesLearnMore()}>了解更多</div>
                </div>
                <div>
                    <div style={{ height: 88 }}></div>
                    <div className="zgh-classicCases-card" >
                        <p className="zgh-menu-title">经典案例</p>
                        <div>
                            <Carousel ref={this.carouselref} dotPosition={"top"} >
                                <div>
                                    <Carousel ref={this.carouselref1} infinite={false} arrows={true} nextArrow={<SampleNextArrow />} prevArrow={<SamplePrevArrow />} dots={false} dotPosition={"top"} >
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-001"></div>
                                                <div className="zgh-classicCases-card-rightDescribe">
                                                    <div className="zgh-classicCases-card-title">湛江钢铁厚板厂超声波探伤缺陷智能应用系统</div>
                                                    <div className="zgh-classicCases-card-describe">基于厚板产线对超声波探伤信息、剪切组板信息、离线探伤信息，实现板坯的内部质量缺陷回溯，并结合炼钢厂的生产过程数据，通过数据融合、数据回溯等技术，实现钢板内部缺陷向连铸板坯的位置映射，支撑连铸产线快速准确锁定产生异常，支持其降低内部缺陷发生率。通过多工序一贯联动优化板坯成品质量，最终提升厚板整体产品合格率。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-002"></div>
                                                <div className="zgh-classicCases-card-rightDescribe">
                                                    <div className="zgh-classicCases-card-title">热轧质量模型类质量异常自动分析</div>
                                                    <div className="zgh-classicCases-card-describe">以热轧产线数据治理、数字孪生钢卷为基础数据底座，从质量缺陷的自动分析为切入点，以分析效率提高、及时改进为抓手，实现产线钢卷质量临时封锁的“卷卷清”。通过规律总结，优化控制过程，实现返修率和废次降率的降低，加快产品流转速度，节约生产成本，通过更好的产品质量，满足客户需求和后道工序的要求。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-003"></div>
                                                <div className="zgh-classicCases-card-rightDescribe">
                                                    <div className="zgh-classicCases-card-title">冷轧C122机组机械性能检测装置深度挖掘和处理</div>
                                                    <div className="zgh-classicCases-card-describe">通过对C122机组现有部分核心数据的深度开发，实现在线卷在线性能检测数据和工艺 数据对应性趋势的展示；对标机械性能检测装置在线检测数据和检化验离线检测结果,形成新钢种在线性能相关检测参数的推荐和老钢种参数优化功能。满足新拓展产品工艺需求，提升超高强钢的生产能力。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-004"></div>
                                                <div className="zgh-classicCases-card-rightDescribe">
                                                    <div className="zgh-classicCases-card-title">连铸4CC状态与铸坯质量相关性研究</div>
                                                    <div className="zgh-classicCases-card-describe">4CC:将连铸机按设备功能逐层解构到最小设备功能单元，并通过对最小单元测点特征值的提取，建立细化的动态功能精度控制标准， 利用系统工具将精度标准配置进系统，在线监测其动态变化，超限报警。构建连铸机设备健 康度评价体系，设备系统按功能组成逐层分解至功能精度，通过底层精度的评价打分规则及其各层各项的权重配置，形成从底层基础分值逐层堆叠形成最终整体评价。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Carousel>
                                </div>
                                <div>
                                    <Carousel ref={this.carouselref1} infinite={false} arrows={true} nextArrow={<SampleNextArrow />} prevArrow={<SamplePrevArrow />} dots={false} dotPosition={"top"} >
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-011"></div>
                                                <div className="zgh-classicCases-card-rightDescribe" style={{ background: "#85B3B5" }}>
                                                    <div className="zgh-classicCases-card-title">2CC连铸状态智能监控技术研究</div>
                                                    <div className="zgh-classicCases-card-describe" >“2CC连铸状态智能监控技术研究”通过数据采集与OT数据治理、数字孪生铸坯、知识中心、多专业应用体系等系列功能，系统性地将连铸相关的操作、工艺、设备管理的各种数据与应用勾连起来，为连铸相关知识的快速迭代，铸机远程运维，以及操作、工艺优化提供平台、创造条件。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-012"></div>
                                                <div className="zgh-classicCases-card-rightDescribe" style={{ background: "#85B3B5" }}>
                                                    <div className="zgh-classicCases-card-title">1880热轧设备健康度评价与设备典型异常监测预警</div>
                                                    <div className="zgh-classicCases-card-describe">以1880热轧大数据采集和治理为基础，以 产线工程师的经验为核心，采用数据应用方式提取数据特征，运用多维分析方法辅助经验提炼和验证经验并形成规则模型；通过对设备功能精度的全要素数字化，基于设备功能精度静态特征管理和动态特性分析，实现设备健康度实时监测和预警；进一步结合轧钢工艺要求、模型设定、生产操作、来料情况和产品质量评估精轧轧制稳定性，实现生产稳定性的智能监测和预警。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Carousel>
                                </div>
                                <div>
                                    <Carousel ref={this.carouselref1} infinite={false} arrows={true} nextArrow={<SampleNextArrow />} prevArrow={<SamplePrevArrow />} dots={false} dotPosition={"top"} >
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-021"></div>
                                                <div className="zgh-classicCases-card-rightDescribe" style={{ background: "#89AD8E" }}>
                                                    <div className="zgh-classicCases-card-title">无缝工业炉智能状态监控及诊断应用系统</div>
                                                    <div className="zgh-classicCases-card-describe" style={{ marginBottom: 34 }}>以无缝7座工业炉L1和L2数据采集和治理为基础，通过采用大数据分析技术对数据特征提取与管理，有效分析工艺、操作、设备等耦合因子对无缝工业炉能耗的影响，开发基于无缝工业炉燃烧状态管理、能耗优化控制精度和操作异常自动预警、性能评价的智能模型，实现无缝工业炉状态智能分析系统集成。</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={contentStyle}>
                                                <div className="zgh-classicCases-card-leftPic leftPic-022"></div>
                                                <div className="zgh-classicCases-card-rightDescribe" style={{ background: "#89AD8E" }}>
                                                    <div className="zgh-classicCases-card-title">1880产线智能节能生产模式技术研究 ISA</div>
                                                    <div className="zgh-classicCases-card-describe" style={{ marginBottom: 34 }}>快速在热轧厂1880产线，通过智能节能数据化应用技术开发，对产线能耗及其相关过程数据、生产实绩数据、钢卷质量结果数据的汇聚、梳理形成数据应用的基础。分别对热轧的燃耗、电耗建模分析、制定不同工况下燃耗、电耗的分摊规则，在线监测每个钢卷能耗，并将燃耗、电耗按品种规格合理分摊到每一个钢卷。
                                                        <br /> 快速在热轧厂1880产线，通过智能节能数据化应用技术开发，对产线 能耗及其相关过程数据、生产实绩数据、钢卷质量结果数据的汇聚、梳理形成数据应用的基础…</div>
                                                    <Button onClick={this.learnMoreClick} style={{ display: "block", border: '1px solid #FFFFFF', background: 'transparent', borderRadius: '0px', color: '#ffffff' }}>了解更多</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Carousel>
                                </div>
                            </Carousel>

                        </div>


                    </div>
                </div>
                <div style={{ width: 1920, margin: ' 0 auto' }}>
                    <p className="zgh-menu-title">服务客户</p>
                    <div style={{ padding: "48px 260px 88px 260px" }}>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img1"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img2"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img3"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img4"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img5"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img6"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img7"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img8"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img9"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img10"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img11"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img12"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img13"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img14"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img15"></div>
                        </div>
                        <div className="zgh-servingCustomers-line">
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img16"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img17"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img18"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img19"></div>
                            <div className="zgh-servingCustomers-icon zgh-servingCustomers-img20"></div>
                        </div>
                    </div>
                </div>
                <div style={{ width: 1920, margin: ' 0 auto' }}>
                    <div className="zgh-company-introduce">
                        <div className="zgh-company-introduce-detailsTab">
                            <div className="zgh-company-introduce-detailsTab-title">智共荟智能科技</div>
                            <div className="zgh-company-introduce-detailsTab-describe">智共荟智能科技成立于2018年，公司位于中国上海。是一家专注于流程型工业，致力于推动全真互联数据工厂的高科技企业。通过数据化技术和元宇宙技术，建立数字孪生产品体系、生产标准体系、知识平台体系、生产判定体系、生产预测体系和一贯制体系，实现预测性生产和预测性管理的数据工厂。</div>
                            <div className="zgh-company-introduce-detailsTab-learnMore">
                                <Button style={{ border: '1px solid rgba(0,0,0,0.2)', borderRadius: 0, color: 'rgba(0,0,0,0.6)' }} onClick={this.introduceLearnMore}>了解更多</Button>
                            </div>
                        </div>
                        <div className="zgh-company-introduce-pic">
                            <Carousel autoplay className="zgh-company-introduce-carousel">
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic1"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic2"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic3"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic4"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic5"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic6"></div>
                                </div>
                                <div>
                                    <div style={picContentStyle} className="zgh-company-introduce-pic7"></div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                    <div className="zgh-company-developmentHistory" id="companyDevelopmentHistory">
                        <div className="zgh-company-developmentHistory-title">公司发展历程</div>
                        <div style={{ position: "relative", height: 598, width: 1920, margin: "0 auto" }}>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 59, left: 269 }}>
                                <div className="zgh-company-developmentHistory-card-pic1"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2018年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">公司成立于上海</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 27, left: 516 }}>
                                <div className="zgh-company-developmentHistory-card-pic2"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2019年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">ISA产线数据应用系统开始预研</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 92, left: 838 }}>
                                <div className="zgh-company-developmentHistory-card-pic3"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2020年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">公司获上海第一批认定高新科技企业</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 104, left: 1151 }}>
                                <div className="zgh-company-developmentHistory-card-pic4"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2021年</div>
                                    <div className="zgh-company-developmentHistory-card-describe">ISA系统成功上线广受好评</div>
                                </div>
                            </div>
                            <div className="zgh-company-developmentHistory-card" style={{ display: "flex", position: 'absolute', bottom: 243, left: 1460 }}>
                                <div className="zgh-company-developmentHistory-card-pic5"></div>
                                <div>
                                    <div className="zgh-company-developmentHistory-card-date">2022年</div>
                                    <div className="zgh-company-developmentHistory-card-describe" style={{ marginBottom: 8 }}>ISA全真互联数据工厂研发成功</div>
                                    <div className="zgh-company-developmentHistory-card-describe" style={{ marginBottom: 8 }}>上海市元宇宙场景第一名</div>
                                    <div className="zgh-company-developmentHistory-card-describe">上海市专精特新</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default withRouter(index)
